// #region Imports
import { motion } from "framer-motion";
import { useEffect, useRef } from "react";
import Stars from "./Stars";
// #endregion


const options = [
	"Do you enjoy crafting user experiences or improving server performance?",
	"Are you drawn to creative development or data management?",
	"Do you prefer building apps from scratch or refining systems?",
	"Are you excited by frontend design or backend complexities?",
];


function Loading({ progress, setProgress }) {

	const quote = useRef(
		options[Math.floor(Math.random() * options.length)]
	);


	useEffect(() => {

		const intervalId = setInterval(() => {

			if (progress >= 100) {
				clearInterval(intervalId);
			} else {
				setProgress(prevProgress => prevProgress + 1);
			}

		}, 20);


		return () => clearInterval(intervalId);

	}, [progress, setProgress]);


	const formattedProgress =
		progress < 10
			? `00${progress}`
			: progress < 100
				? `0${progress}`
				: `${progress}`;


	return (
		<div
			className="
				fixed inset-0
				w-screen h-screen
				bg-ivory text-charcoal
				loader z-50 cursor-wait
				overflow-hidden
			"
		>

			<motion.div
				className="
					relative
					w-full h-full
					bg-ivory
					overflow-hidden
					flex items-center
					justify-center
				"
				initial={{
					opacity: 0,
				}}
				animate={{
					opacity: 1,
				}}
				transition={{
					duration: 0.6,
					ease: "easeOut",
				}}
			>

				{/* STARS */}

				<Stars />


				{/* CONTENT */}

				<div
					className="
						relative z-20
						w-[70%]
						max-w-[75rem]
						flex flex-col
						items-start
						gap-5
						small:w-[82%]
						small:gap-4
					"
				>

					{/* PROGRESS */}

					<div
						className="
							flex items-center
							gap-4
							w-full
						"
					>

						<span
							className="
								font-luimp
								font-[600]
								text-[clamp(2rem,4vw,4.5rem)]
								tracking-widest
								leading-none
								tabular-nums
							"
						>
							{formattedProgress}
						</span>

					</div>


					{/* QUOTE */}

					<motion.p
						className="
							max-w-[55rem]
							font-luimp
							font-[300]
							leading-[0.95]
							tracking-tightest
							text-left text-5xl
							small:leading-[1]
                            small:text-3xl
						"
						initial={{
							opacity: 0,
							y: 15,
						}}
						animate={{
							opacity: 1,
							y: 0,
						}}
						transition={{
							delay: 0.25,
							duration: 0.7,
							ease: [0.22, 1, 0.36, 1],
						}}
					>
						{quote.current}
					</motion.p>
				</div>

			</motion.div>

		</div>
	);
}


export default Loading;